import { render, staticRenderFns } from "./Regular.vue?vue&type=template&id=bc205c16&scoped=true"
import script from "./Regular.vue?vue&type=script&lang=js"
export * from "./Regular.vue?vue&type=script&lang=js"
import style0 from "./Regular.vue?vue&type=style&index=0&id=bc205c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc205c16",
  null
  
)

export default component.exports